module.exports = __webpack_public_path__ + "static/img/fhabian-research.a37537b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jpgs/fhabian-research.jpg
// module id = 0n6M
// module chunks = 1